export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/Secure.50a2babf.svg","height":26,"width":24,"blurWidth":0,"blurHeight":0};